import BaseService from 'config/bridge/BaseService'
import { IContentManagerResponse } from 'store/contentManager/types'

export default class ContentManagerService {
  static async getContentManager() {
    try {
      const response = await BaseService.doExecute<IContentManagerResponse>({
        method: 'GET',
        endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/content-manager`,
      })

      return response.data
    } catch (error) {
      console.error('Error getting content manager:', error)
      return null
    }
  }
}
